import CommanHeroSection, {
  type CommanHeroSectionProps,
} from '../../atoms/CommanHeroSection/CommanHeroSection'
import ScrollHeader from '../../atoms/ScrollHeader/ScrollHeader'
import TechnoDetails, { type TechnoDetailsProps } from '../../atoms/TechnoDetails/TechnoDetails'
// import CommonHeroSection from '../commonherosection/CommonHeroSection'
export type TechnologyPageIntroProps = {
  hero: CommanHeroSectionProps
  scrollBannerText: string | string[]
  details: TechnoDetailsProps
}

const TechnologyPageIntro = ({ hero, scrollBannerText, details }: TechnologyPageIntroProps) => {
  return (
    <>
      <CommanHeroSection {...hero} />
      <ScrollHeader bannerText={scrollBannerText} />
      <TechnoDetails {...details} />
    </>
  )
}

export default TechnologyPageIntro
